import {RootState} from '../rootReducer';
import {VersionInfoDTO} from 'hemwb-api';

export const appDataSelector = (state: RootState) => state.appData;
export const appDataVersionSelector = (state: RootState): VersionInfoDTO | null => state.appData.version.value;
export const appDataSettingsSelector = (state: RootState) => state.appData.settings.value;
